import React, { useCallback, useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg';
import { useLocation } from 'react-router-dom';

import { breakpoints, colors, dimensions, fluidRange, fontSmoothing, styled, transitionDefault } from '~/styles';
import { Stylable } from '~/types';

import hamburgerIcon from '~/assets/images/hamburger-icon.svg';
import { openModal } from '~/redux/actions';
import { useDispatch } from '~/redux';
import ImportantSafetyInformationModal from '~/components/modals/ImportantSafetyInformationModal';
import HamburgerMenu from './HamburgerMenu';


const HamburgerMenuIcon = styled.button`
  height: 100%;
  display: flex;
  align-items: center;
  ${fluidRange('fontSize', '18px', '26px', 
    breakpoints.xs, dimensions.mobileMenuBreakpoint)
  };
  padding: 0 0.9em !important;
  cursor: pointer;
  
  ${transitionDefault};
  transition-property: background-color;

  img, svg {
    height: 1em;
    max-width: none;
    vertical-align: text-bottom;
  }

  svg {
    path {
      ${transitionDefault};
      transition-property: fill;
    }
  }
  
  &.active {
    background-color: ${colors.white};
    svg {
      path {
        fill: ${colors.black};
      }
    }
  }
`

const ButtonsContainer = styled.section`
  display: flex;
  flex-flow: row;
  height: 100%;
  align-items: center;
  justify-content: flex-end;
`

const MobileHeaderButtonLink = styled.button`
  ${fluidRange('fontSize', '18px', '26px', 
    breakpoints.xs, dimensions.mobileMenuBreakpoint)
  };
  font-weight: 900; 
  position: relative;
  padding: 0 0.9em !important;
  ${fontSmoothing};
  cursor: pointer;
  margin-right: -1px;

  &:after {
    content: '';
    width: 1px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    background: ${colors.white};
  }

  &.active {

  }
`

interface Props extends Stylable {}
const PageHeaderMobileContent: React.FC<Props> = ({ className }) => {
  const [menuOpened, setMenuOpened] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  const openModal_ = useCallback((modalContent) => {
    dispatch(openModal({
      content: modalContent
    }));
  }, [dispatch]);

  const toggleMenu = useCallback(() => {
    setMenuOpened(!menuOpened);
  }, [menuOpened]);

  const closeMenu = useCallback(() => {
    setMenuOpened(false);
  }, []);

  // make sure to close menu when navigating
  useEffect(() => {
    closeMenu();
  }, [location.pathname, closeMenu])

  // close menu when any link on header clicked
  useEffect(() => {
    const headerLinks = document.getElementById('header-container')?.querySelectorAll('a');
    headerLinks?.forEach( l => {
      l.addEventListener('click', closeMenu);
    })

    return () => {
      headerLinks?.forEach( l => {
        l.removeEventListener('click', closeMenu);
      })
    }
  }, [closeMenu])

  useEffect(() => {
    document.body.classList[menuOpened ? 'add' : 'remove']('noscroll');
  }, [menuOpened]);

  return (
    <div className={className}>
      <ButtonsContainer>
        <MobileHeaderButtonLink
          onClick={() => openModal_(<ImportantSafetyInformationModal />)}
        >
          <span>ISI</span>
        </MobileHeaderButtonLink>
        <HamburgerMenuIcon
          onClick={toggleMenu} 
          className={`
            ${menuOpened ? 'active' : ''}
          `} 
        >
          <ReactSVG src={hamburgerIcon} />
        </HamburgerMenuIcon>
      </ButtonsContainer>
      <HamburgerMenu isOpened={menuOpened} close={closeMenu}/>
    </div>
  )
}

export default PageHeaderMobileContent;


// WEBPACK FOOTER //
// ./src/components/layout/header/PageHeaderMobileContent.tsx